import {
    SET_CURRENT_CUSTOMER,
    SET_CURRENT_PARTNER,
} from './types';

export default {
    [SET_CURRENT_CUSTOMER](state: { currentCustomer: any; }, response: any) {
        state.currentCustomer = response;
    },

    [SET_CURRENT_PARTNER](state: { currentPartner: any; }, response: any) {
        state.currentPartner = response;
    },
};
